module.exports = __webpack_public_path__ + "static/media/400037_01.648f9646.png";